import { FC } from 'react'
import { Helmet } from 'react-helmet'
import 'swiper/css/bundle'

import { GlobalStyle } from 'styles/global'
import { Configurable } from 'models'
import { config } from 'config'
import { Home } from 'containers/home'
import { Tatarstan } from 'containers/tatarstan'
import { Komi } from 'containers/komi'
import { Buryatiya } from 'containers/buryatiya'
import { Caxa } from 'containers/caxa'
import { AppContextProvider } from 'context/app-context'
import { NavContextProvider } from 'context/nav-context'

const pages: { [k in Configurable['buildTarget']]: FC } = {
  homepage: Home,
  Бурятия: Buryatiya,
  Главная: Home,
  Коми: Komi,
  Татары: Tatarstan,
  Caxa: Caxa,
  Erzya: Home,
}

const PageTitle = () => {
  return (
    <Helmet>
      <title>Анализируй Этно</title>
    </Helmet>
  )
}

function App() {
  const queryParam = new URLSearchParams(document.location.search).get('page')
  const Component =
    queryParam && queryParam in pages
      ? pages[queryParam as Configurable['buildTarget']]
      : pages[config.buildTarget]

  return (
    <AppContextProvider>
      <NavContextProvider>
        <PageTitle />
        <GlobalStyle />
        <Component />
      </NavContextProvider>
    </AppContextProvider>
  )
}

export default App
